import {
  BOARD_STATUSES,
  TOPIC_STATUSES,
  type BoardStatus,
  type TopicStatus,
} from "../types";

const ORDER: TopicStatus[] = [...TOPIC_STATUSES];

export function isTopicStatus(value: string | null | undefined): value is TopicStatus {
  return !!value && (TOPIC_STATUSES as readonly string[]).includes(value);
}

export function parseTopicStatus(value: string | null | undefined): TopicStatus | null {
  const trimmed = value?.trim();
  return isTopicStatus(trimmed) ? trimmed : null;
}

export function isBoardStatus(value: TopicStatus): value is BoardStatus {
  return (BOARD_STATUSES as readonly string[]).includes(value);
}

export function nextBoardStatus(status: TopicStatus): TopicStatus | null {
  const index = BOARD_STATUSES.indexOf(status as BoardStatus);
  if (index < 0 || index >= BOARD_STATUSES.length - 1) return null;
  return BOARD_STATUSES[index + 1] ?? null;
}

export function previousBoardStatus(status: TopicStatus): TopicStatus | null {
  if (status === "已确认") return "待确认";
  const index = BOARD_STATUSES.indexOf(status as BoardStatus);
  if (index <= 0) return null;
  return BOARD_STATUSES[index - 1] ?? null;
}

export function statusLabel(status: TopicStatus): string {
  return status;
}

export function statusIndex(status: TopicStatus): number {
  const index = ORDER.indexOf(status);
  return index < 0 ? ORDER.length : index;
}
